import { inject } from '@angular/core';
import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';

import { DeviceService } from '@core/device';
import { resolveDisplayHeader } from './header-visibility';

// App-wide chrome state. Owns whether the global header/footer show and whether
// the current page is the programme guide (footer is hidden there). Replaces the
// boolean fields that used to live on AppComponent; written by NavigationUiService
// on router events and by the error/more pages that force the header off.

interface LayoutState {
    displayHeader: boolean;
    programme: boolean;
}

const initialState: LayoutState = {
    displayHeader: true,
    programme: false,
};

export const LayoutStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store, device = inject(DeviceService)) => ({
        setDisplayHeader(value: boolean): void {
            patchState(store, { displayHeader: value });
        },
        setProgramme(value: boolean): void {
            patchState(store, { programme: value });
        },
        // Resolve header/footer visibility for a URL — used as the boot seed and
        // on every NavigationEnd.
        applyForUrl(url: string): void {
            patchState(store, { displayHeader: resolveDisplayHeader(url, device.isWebView()) });
        },
    })),
);

// Mirror the inferred instance type onto the value name so callers can write
// `: LayoutStore` without `InstanceType<...>`.
export type LayoutStore = InstanceType<typeof LayoutStore>;
